export const calculateMgPlus = (E: number, Q?: number, unitClaim?: string, active?: number): number | undefined => {
  if (!Q || !unitClaim || !active) {
    return 0;
  }
  const baseValue = (Q * 100) / active + (((Q * 100) / active) * E) / 100;

  if (unitClaim === 'mg') {
    return parseFloat(baseValue.toFixed(2));
  } else if (unitClaim === 'ug') {
    return parseFloat((baseValue / 1000).toFixed(6));
  } else {
    return;
  }
};

export const calculatePercentageFormula = (mgPlus?: number, totalMgPlus?: number): number | undefined => {
  if (!mgPlus || !totalMgPlus || totalMgPlus === 0) {
    return;
  }

  return parseFloat(((mgPlus * 100) / totalMgPlus).toFixed(2));
};

export const calculatePercentageVRN = (
  Q?: number,
  vrnBase?: number,
  unitClaim?: string,
  unitVrn?: string,
): number | string => {
  const vrnBaseNumber = Number(vrnBase);
  if (!Number.isFinite(vrnBaseNumber) || vrnBaseNumber <= 0) {
    return '-';
  }

  const quantityNumber = Number(Q);
  if (!Number.isFinite(quantityNumber) || quantityNumber <= 0) {
    return '-';
  }

  let QInVrnUnits = quantityNumber;

  if (unitClaim === 'mg' && unitVrn === 'ug') {
    QInVrnUnits = quantityNumber * 1000;
  } else if (unitClaim === 'ug' && unitVrn === 'mg') {
    QInVrnUnits = quantityNumber / 1000;
  } else if (unitClaim === 'mg' && unitVrn === 'g') {
    QInVrnUnits = quantityNumber / 1000;
  } else if (unitClaim === 'ug' && unitVrn === 'g') {
    QInVrnUnits = quantityNumber / 1000000;
  }

  return parseFloat(((QInVrnUnits / vrnBaseNumber) * 100).toFixed(2));
};

export const resolveVrnBase = (_ul?: number | string | null, vrn?: number | string | null): number | undefined => {
  const vrnNumber = Number(vrn);
  if (Number.isFinite(vrnNumber) && vrnNumber > 0) {
    return vrnNumber;
  }

  return undefined;
};

export const calculateMissingMg = (dosage: number, totalMgPlus: number): number => {
  if (totalMgPlus === 0 || isNaN(totalMgPlus)) {
    return dosage;
  }
  if (!totalMgPlus) {
    return dosage;
  }

  return dosage - totalMgPlus;
};

export const calculateSecondaryActiveMg = (mgPlus?: number, activePercentage?: number): number => {
  if (mgPlus == null || activePercentage == null) {
    return 0;
  }

  const numericMgPlus = Number(mgPlus);
  const numericPercentage = Number(activePercentage);

  if (isNaN(numericMgPlus) || isNaN(numericPercentage)) {
    return 0;
  }

  return parseFloat(((numericMgPlus * numericPercentage) / 100).toFixed(2));
};
